import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import SouthIcon from "@mui/icons-material/South";
import { useNavigate } from "react-router-dom";
export const WhatWeDoButton = () => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate("/What-we-do")}
      className="w-fit p-4 cursor-pointer hover:scale-[1.1]  px-8 rounded-[60px] text-black font-[400] flex flex-row items-center gap-5 uppercase bg-[#FBE204]"
    >
      <strong className="text-[1.15rem] font-[500] text-[#1D4111]">
        what we do
      </strong>{" "}
      <span className="bg-[#35751F]  rounded-full  p-2 px-[8px] flex items-center justify-center w-fit h-fit">
        <img className="w-4" src={require("../assets/arrow-icon.png")} alt="" />
      </span>
    </div>
  );
};

export const ViewOurWorks = () => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate("/our-works")}
      className="cursor-pointer w-fit p-3 px-4 hover:scale-[1.1] border border-[#FBE204] rounded-[60px] text-white font-[400] flex flex-row items-center gap-5 uppercase"
    >
      <strong className="text-[1.15rem] font-[500] ">view our works</strong>{" "}
      <span className=" bg-[#FBE204] rounded-full  p-2 px-[8px] flex items-center justify-center w-fit h-fit">
        <img
          className="w-4"
          src={require("../assets/green-arrow.png")}
          alt=""
        />
      </span>
    </div>
  );
};
export const BottomScroll = () => {
  return (
    <div className="cursor-pointer flex justify-end rounded-full w-fit h-fit bg-[#FBE204] p-3">
      <span className="bg-[#35751F]  rounded-full  p-2 px-[8px] flex items-center justify-center w-fit h-fit">
        <img className="w-4" src={require("../assets/arrow-icon.png")} alt="" />
      </span>
    </div>
  );
};
export const ReadMore = () => {
  return (
    <div className=" w-fit p-4 px-8 cursor-pointer hover:scale-[1.1] rounded-[60px] text-black font-[400] flex flex-row items-center gap-5 uppercase bg-[#FBE204]">
      <strong className="text-[1.15rem] font-[500] text-[#1D4111]">
        Read more
      </strong>{" "}
      <span className="bg-[#35751F]  rounded-full  p-2 px-[8px] flex items-center justify-center w-fit h-fit">
        <img className="w-4" src={require("../assets/arrow-icon.png")} alt="" />
      </span>
    </div>
  );
};
export const ContactUs = () => {
  return (
    <div className="cursor-pointer w-fit hover:scale-[1.1] p-4 px-8 rounded-[60px] text-black font-[400] flex flex-row items-center gap-5 uppercase bg-[#FBE204]">
      <strong className="text-[1.15rem] font-[500]">Contact Us</strong>{" "}
      <span className="bg-[#35751F] rounded-full  p-1 flex items-center justify-center w-fit h-fit">
        <ArrowRightAltIcon style={{ fontSize: "20px", color: "#FBE204" }} />
      </span>
    </div>
  );
};
export const JoinUs = ({ screen }) => {
  const navigate = useNavigate();
  const careerHandler = () => {
    if (screen === "home") {
      localStorage.setItem("active", "career");
    } else {
      localStorage.setItem("active", "careers");
    }
    navigate("/careers");
  };
  return (
    <div
      onClick={careerHandler}
      className="w-fit p-4 hover:scale-[1.1] cursor-pointer px-8 rounded-[60px] text-black font-[400] flex flex-row items-center gap-5 uppercase bg-[#FBE204]"
    >
      <strong className="text-[1.15rem] font-[500] text-[#1D4111]">
        Join Us
      </strong>{" "}
      <span className="bg-[#35751F]  rounded-full  p-2 px-[8px] flex items-center justify-center w-fit h-fit">
        <img className="w-4" src={require("../assets/arrow-icon.png")} alt="" />
      </span>
    </div>
  );
};

export const RightArrowIcon = () => {
  return (
    <span className="bg-[#35751F]  rounded-full  p-2 px-[8px] flex items-center justify-center w-fit h-fit">
      <img className="w-4" src={require("../assets/arrow-icon.png")} alt="" />
    </span>
  );
};

export const ExploreSolution = () => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate("/agentic-solutions")}
      className="w-fit p-4 cursor-pointer hover:scale-[1.02] group  px-8 mobile:p-2 rounded-[60px] text-black font-[400] flex flex-row items-center gap-5 bg-[#F7E14D]"
    >
      <strong className="text-[1.4rem] mobile:text-[1rem] font-semibold text-[#2B421E]">
        Explore Solution
      </strong>{" "}
      <span className="bg-[#2D4D18]  transition-transform group-hover:-rotate-45 rounded-full  p-2 px-[8px] flex items-center justify-center w-fit h-fit">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
        >
          <path
            d="M16.5484 9.81791C16.653 9.81798 16.7566 9.83866 16.8533 9.87878C16.9499 9.91889 17.0378 9.97764 17.1117 10.0517C17.1856 10.1257 17.2443 10.2136 17.2843 10.3103C17.3243 10.407 17.3448 10.5107 17.3447 10.6153C17.3447 10.72 17.324 10.8236 17.2839 10.9202C17.2438 11.0169 17.185 11.1047 17.111 11.1786C17.0369 11.2526 16.949 11.3112 16.8523 11.3512C16.7556 11.3912 16.652 11.4117 16.5473 11.4117L16.5484 9.81791ZM15.3472 10.6143V9.81738H15.3478L15.3472 10.6143ZM10.0151 11.4111C9.80373 11.4111 9.60104 11.3272 9.45159 11.1777C9.30215 11.0283 9.21819 10.8256 9.21819 10.6143C9.21819 10.4029 9.30215 10.2002 9.45159 10.0508C9.60104 9.90134 9.80373 9.81738 10.0151 9.81738V11.4111ZM10.0052 9.81738C10.2166 9.81738 10.4193 9.90134 10.5687 10.0508C10.7182 10.2002 10.8021 10.4029 10.8021 10.6143C10.8021 10.8256 10.7182 11.0283 10.5687 11.1777C10.4193 11.3272 10.2166 11.4111 10.0052 11.4111V9.81738ZM4.24995 11.4111C4.0386 11.4111 3.83591 11.3272 3.68647 11.1777C3.53703 11.0283 3.45307 10.8256 3.45307 10.6143C3.45307 10.4029 3.53703 10.2002 3.68647 10.0508C3.83591 9.90134 4.0386 9.81738 4.24995 9.81738V11.4111ZM16.5473 11.4117H16.5274L16.5282 9.81791H16.5484L16.5473 11.4117ZM16.5274 11.4117H16.291L16.2923 9.81791H16.5282L16.5274 11.4117ZM16.291 11.4117H16.0551L16.0562 9.81791H16.2923L16.291 11.4117ZM16.0551 11.4117L15.8187 11.4114L15.82 9.81765L16.0562 9.81791L16.0551 11.4117ZM15.8187 11.4114L15.5828 11.4111L15.5839 9.81738L15.82 9.81765L15.8187 11.4114ZM15.5828 11.4111H15.3467L15.3478 9.81738H15.5839L15.5828 11.4111ZM15.3472 11.4111H10.0151V9.81738H15.3472V11.4111ZM10.0052 11.4111H4.24995V9.81738H10.0052V11.4111Z"
            fill="white"
          />
          <path
            d="M10.8614 4.01367L16.4863 9.63881C16.6158 9.76831 16.7185 9.92205 16.7886 10.0912C16.8587 10.2604 16.8948 10.4418 16.8948 10.6249C16.8948 10.8081 16.8587 10.9894 16.7886 11.1586C16.7185 11.3278 16.6158 11.4816 16.4863 11.6111L10.8611 17.236"
            stroke="white"
            strokeWidth="1.59375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </div>
  );
};
